import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Creation from './CreationComponent';
import actions from '../actions';

import coreActions from '../../../core/actions';

const allActions = { ...coreActions, ...actions };

const mapStateToProps = (state, props) => ({
  config: state.config,
  ...state.creationSettings,
  parentLocation: state.newProduct.parentLocation,
  runtimeConfig: props.runtimeConfig,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(Creation);
